<template>
<div class="people">
    <h3>王安安 <el-tag  type="success">男</el-tag>  <el-tag>23岁</el-tag></h3>
    <img src="https://cdn.nlark.com/yuque/0/2018/jpeg/92616/1543724341302-assets/web-upload/7f119bd6-6298-44fc-9f11-778d28be523b.jpeg" alt="">
    <h4>患病</h4>
    <div class="jb-list">
        <el-tag size="medium" >颈椎病</el-tag>
    </div>
    <h4>疾病详情</h4>
    <el-tabs :tab-position="tabPosition">
        <el-tab-pane label="治疗">
            <h4>治疗</h4>
            <h5>手术方式治疗</h5>
            <p>颈椎病的治疗方式分为手术方式和非手术方式，多数颈椎病可以采用理疗、按摩等非手术方法对症状进行缓解，而对有些颈椎病如脊髓型颈椎病效果不好，这类颈椎病可能需要手术治疗，其他的如正确的生活方式及工作姿势也是治疗非常重要的一部分。</p>
            <h5>非手术方式治疗</h5>
            <p>绝大多数颈椎病通过各种治疗方法症状可以缓解，特别是病情比较单一、诊断比较明确的颈椎病效果较好，但颈椎病毕竟是个退变性疾病，往往症状会出现反复，所以一定要注意平时保健，防止复发。</p>
            <h5>止痛剂治疗</h5>
            <p>在医生指导下，急性疼痛期可选择性应用止痛剂如非甾体药物布洛芬、塞来昔布、镇静剂，伴有眩晕者可选用扩张脑血管、营养神经、增加脑血流量药物如维生素 B1、B12 等，对症状的缓解有一定的效果。服用扩血管，改善微循环药物对于部分颈椎病效果较好。</p>
            <h5>缓解症状手段</h5>
            <p>颈椎牵引是治疗颈椎病的主要缓解症状手段。因为有效的牵引能缓解神经、血管、脊髓的压迫，并快速缓解颈椎病症状。 具体的讲，颈椎牵引主要是解除颈部肌肉痉挛，缓解疼痛症状，增大椎间隙和椎间孔，有利于已外突的髓核及纤维环组织复位，缓解和解除神经根受压与刺激，促进神经根水肿吸收，解除对椎动脉的压迫，促进血液循环，有利于局部淤血肿胀及增生消退，松懈粘连的关节囊，改善和恢复钩椎关节，调整小关节错位和椎体滑脱，调整和恢复已被破坏的颈椎内外平衡，恢复颈椎的正常功能。适用于轻度颈椎病、经常落枕、颈椎生理曲度改变患者。</p>
            <h5>颈椎牵引有什么注意事项</h5>
            <p>牵引角度：一般来说颈部自躯干纵轴向前前倾约 10°~30°（上颈段、中颈段、下颈段），避免过伸（椎间盘突出除外）。</p>
            <p>牵引重量：原则上以病人能忍受为宜，根据不同的年龄，选择不同的牵引重量，一般不超过15kg。</p>
            <p>牵引时间：一般每日牵引 1~2 次，每次牵引 30 分钟左右，具体应根据病人体质而定。</p>
            <p>牵引方式：一般使用坐式间歇牵引，对年老体弱者通常使用卧式间歇牵引。牵引重量可自 3~4 公斤开始，小重量牵引 7 天为一疗程。</p>
            <h5>颈椎病带颈托</h5>
            <p>颈椎病早期带颈托是有用的，特别对于纠正不良姿势，特别是长期低头者，另外对于颈椎不稳，容易落枕的患者有效。对于椎动脉型颈椎病患者，因常有扭头时眩晕，颈托保护可以防止症状发作。</p>
            <h5>颈椎病需要手术治疗</h5>
            <p>颈椎病的治疗方式分为手术方式和非手术方式，多数颈椎病可以采用理疗、按摩等非手术方法对症状进行缓解，只有脊髓型、神经根型和椎动脉型颈椎病的患者需要进行手术治疗。因为颈椎部位有神经、血管、脊髓等重要组织，一些患者对手术产生恐惧心理。但目前我国治疗颈椎病的手术技术已经取得了长足的进步，基本与国际接轨。只要患者到正规大医院的专科进行手术，手术安全一般是有保障的。</p>
            <h5>颈椎手术有哪些风险</h5>
            <p>颈椎病手术风险较大。颈椎病手术分不同的类型，有微创手术，也有颈椎前路和后路的开放性手术。对于微创手术，很多是在局部麻醉下手术治疗，病人是清醒的，一般来说安全性还是比较高的，触碰到旁边的神经，患者会及时反馈到医生；而对于前后路的开放性手术，如椎体融合术、后路开窗手术等，虽然是有神经电位的监视和影像导航技术的发展，但因颈椎里面的脊髓神经位置高，特别是上位脊髓神经如生命中枢延髓，而里面的血管，椎动脉和颈内动脉等是供应脑部的血管，不可以随便结扎，所以一旦有脊髓神经或者是大的动脉血管的损伤，容易出现较大的损伤，所以手术风险相对较大，一般是在三甲医院开展。</p>
            <h5>颈椎病患者可以做哪些康复训练</h5>
            <p>绝大多数颈椎病患者通过姿势调整、特别是睡姿调整、适当休息以及正确的颈肩背部肌肉锻炼就能恢复健康或是大幅度缓解症状。每日可自行锻炼一次。手法由轻渐重，以能忍耐为度，一般 1-2 月即可见效。</p>
            <p>颈部运动：头向前倾十次，向后仰十次，向左倾十次，向右倾十次。然后缓慢摇头，左转十次，右转十次；</p>
            <h5>推荐药品 <el-tag type="info" size="small">已支付</el-tag></h5>
            <div class="drug_p">
                <drug></drug>
                <drug3></drug3>
                <div class="c-t">
                    <router-link to="/Peoplex/2">    
                        <el-button type="success" plain>购药详情<i class="el-icon-location-outline el-icon--right"></i></el-button>
                    </router-link>
                </div>
            </div>
            <div class="c-t l_f">
                <router-link to="/Peoplex/1">
                    <el-button type="success"  icon="el-icon-circle-plus-outline">登记近况</el-button>
                </router-link>
            </div>
        </el-tab-pane>
        <el-tab-pane label="症状">
            <h4>症状</h4>
            <h5>神经根型</h5>
            <p>发病率最高，表现为受累神经根对应区域的神经痛、感觉障碍、麻木，异样感，活动不灵活。仰头、咳嗽、喷嚏可加重，就医时间越早，疗效越好，大部分病人可以部分缓解，不需手术治疗。</p>
            <h5>脊髓型</h5>
            <p> 约 10~15% 病人为此型。当发生椎间盘突出、骨质增生，或连接骨关节的韧带增厚或骨化时，可压迫脊髓及血管，甚至发生脊髓缺血或坏死。早期为单侧或双侧下肢麻木，以后发展为行走困难和大小便功能障碍甚至瘫痪。</p>
            <h5>交感神经型</h5>
            <p>约占 5%。因颈部交感神经受压产生的症状。因其分布广泛，因此可引起许多器官和系统的症状。包括头部症状：头晕，头痛，颈后痛；眼部症状：眼睑下垂，视物模糊，甚至失明；心脏症状：心跳加速或减慢，心口疼；周围症状：肢体、头、颈、面部发麻或疼痛；其他：耳鸣、耳聋等。</p>
            <h5>椎动脉型</h5>
            <p>约占 2%。是由于椎动脉受到外来的压迫或刺激，引起功能失调，脑部供血不足而产生的一系列症状。早期症状一般不明显，加重到一定程度，在特殊的体位下表现为突然发病，只要颈部向某个方向转动一下，当即出现眩晕，甚至感到天昏地暗。有时伴有头疼，恶心呕吐，耳鸣，视物不清等。</p>
        </el-tab-pane>
        <el-tab-pane label="病因">
            <h4>病因</h4>
            <h5>颈椎病的发病原因和机制是什么？</h5>
            <p>颈椎病是一种以退行性病理改变为基础的疾患，其发病原因很多，但综合起来有四个，包括颈椎的退行性变（颈椎增生，椎间盘突出等）、慢性劳损（最常见到的原因如低头工作等）、发育性颈椎椎管狭窄（多为先天性）、颈椎的先天性畸形（比较少见，如蝴蝶椎、并椎等）。</p>
            <p>前两者是主要原因，由于颈椎长期劳损、骨质增生，或椎间盘脱出、韧带增厚，致使颈椎脊髓、神经根或椎动脉受压，表现为颈椎间盘退变本身及其继发性的一系列病理改变，如椎节失稳、松动；髓核突出或脱出；骨刺形成；韧带肥厚和继发的椎管狭窄等，刺激或压迫了邻近的神经根、脊髓、椎动脉及颈部交感神经等组织，引起一系列症状和体征。</p>
            <h4>颈椎病是不是就是椎间盘突出引起的？</h4>
            <p>椎间盘突出是颈椎病的常见原因之一，是颈椎退变的一种表现形式（类似于老人的头发变白），可以导致脊髓及血管神经压迫，引起颈椎病，但不是唯一原因，有些患者椎间盘突出很明显，但常常没有临床症状，也无需特殊治疗。</p>
            <h4>颈椎病是不是就是颈椎骨质增生？</h4>
            <p>颈椎退行性改变是颈椎病发病的主要原因，颈椎的骨质增生（骨刺）也是中老年人的一种退变表现形式，是一种自然地老化，本身没有什么危害，甚至对于维持椎体稳定还有一定好处，所以不可谈起骨刺色变，但骨质增生如果压迫颈椎周围的神经血管就可导致颈椎病，那就需要治疗了。</p>
            <h4>颈椎病是不是老年人才会发生的？</h4>
            <p>颈椎病是中老年人的常见病、多发病之一。有统计表明，在 50 岁左右的人群中大约有 25% 的人患过或正患此病，60 岁左右则达 50%。调查显示，全国大约有 7%~10% 的人患颈椎病，但目前，普遍存在对该病早期重视不够，不能在出现症状时自我识别判断，致使该病发展到晚期可能致人瘫痪等危害。 但近年来罹患此病的年轻人有增加趋势，且工作集中在头颈部长期处于同一姿势的人，或头颈部活动频繁、从事颈部容易受伤职业者，像是久坐办公桌的白领阶层、电脑操作员、会计、教师、学生等，这些需长期伏案工作的职业，如果姿势不正确，罹患颈椎病的机率比一般人高了 4 到 6 倍，所以也不可掉以轻心。</p>
        </el-tab-pane>
        <el-tab-pane label="诊断">
            <h4>诊断</h4>
            <h5>有哪些症状提示可能得了颈椎病？</h5>
            <p>颈椎病的种类颇多，症状复杂，有时往往只有一个表现， 由于颈椎病容易误诊，如果身体有以下表现，就要想到是不是颈椎出了问题：走路有踩棉花感、经常颈肩部疼痛，颈部不适，上肢麻木放射痛，行走发飘乏力，久治不愈的头痛或偏头痛；久治不愈的头晕；非耳部原因的持续耳鸣或听力下降；不明原因的心律不齐、类似心绞痛的症状等。</p>
            <h5>怀疑颈椎病要做哪些检查？</h5>
            <p>颈椎病的检查包括物理检查和辅助检查，物理检查要经医生检查明确有无颈椎病的症状，包括局部是否有压痛点、颈椎活动范围及一些颈椎试验检查。此外，为了定位诊断或鉴别诊断，对感觉、运动、反射等神经系统方面的检查，有时也酌情予以选择。例如：手部和上肢的感觉障碍分布区，与受累颈椎椎节定位有直接关系。运动检查，主要是进行肌张力、肌力、步态等方面的检查。</p>
            <p>辅助检查有 X 线检查，磁共振成像，CT，还有脊髓造影、椎动脉造影等。另外，为了鉴别诊断，可根据需要进行脑脊液检查、肌电图、脑血流图等检查。</p>
            <h5>X 线检查对颈椎病诊断有什么意义？</h5>
            <p>常规的辅助检查，主要为 X 线检查，可拍摄颈椎正位、侧位、斜位平片等。正位：观察有无枢环关节脱位、齿状突骨折或缺失等先天性异常；第七颈椎横突有无过长，有无颈肋；钩椎关节及椎间隙有无增宽或变窄。</p>
        </el-tab-pane>
        <el-tab-pane label="生活">
            <h4>生活</h4>
            <h5>颈椎病与从事的工作有关么？</h5>
            <p>颈椎病是中老年专利的传统正逐渐为现实所改写， 现代文明的进步，体力劳动逐渐被机器取代，伏案工作的增加及运动量的不足使颈椎病发生率迅速上升，并且明显趋向低龄化。大量统计材料表明某些工作量不大，强度不高，但处于坐位，尤其是低头工作者的颈椎病发病率特高，包括家务劳动者、刺绣女工、办公室人员、打字抄写者、仪表流水线上的装配工等。</p>
            <h5>哪些运动有助于缓解颈椎病症状？</h5>
            <p>运动是颈椎病的最好治疗方法之一，运动能够增加自身体质、锻炼肌肉、坚固骨骼，而且能使处于紧张状态下的肌肉得到松弛，从而达到防治颈椎病的效果。较好的运动如太极拳、羽毛球、乒乓球、游泳、放风筝等。太极拳的招式中非常重视站姿及头、眼、颈和四肢的配合和协调，在打羽毛球的过程中，头部会随着羽毛球的运动做前屈、后伸、 左转、右转等放松性运动，对于长期伏案、埋头工作的上班族而言，在回接高球时，抬头看球的动作还可以很好地起到「反向治疗」的效果。且向后引臂的回球动作，亦能令颈椎与脊椎处于放松状态，缓解肩膀酸痛，因而能很好地防治颈椎病。</p>
            <h5>颈椎病有哪些家庭物理疗法？</h5>
            <p>家庭物理疗法不仅可以巩固正规治疗的疗效，降低治愈后的复发，而且可提高病者对疾病的深入了解和增强保健意识，减少经济开支。最易进行的是温热敷和红外线等理疗。热毛巾、热水袋、热水澡等都是进行温热敷的便利条件。加热的石蜡、白炽灯等则是很好的红外线发射器。此外，热敷袋、场效应治疗仪、小型红外线辐射灯等也可应用于家庭理疗。这些简易的理疗方法可改善血液循环，缓解肌肉痉挛，消除肿胀和减轻症状，有助于巩固和提高正规治疗的效果。</p>
        </el-tab-pane>
        <el-tab-pane label="预防">
            <h4>预防</h4>
            <h5>如何预防颈椎病？</h5>
            <p>要定期改变头颈部体位，每当伏案工作过久后，应抬头远视几分钟，待眼睛疲劳消除后再工作；加强颈肩部肌肉的锻炼，在工间或工余时，做头及双上肢的前屈、后伸及旋转运动；避免高枕睡眠的不良习惯，高枕使头部前屈，增大下位颈椎的应力，有加速颈椎退变的可能，枕头不宜过高或过低，切忌 「高枕无忧」，以生理位为佳，一般讲，枕头高以 8~15 cm 为宜，或按公式计算：（肩宽 - 头宽）÷ 2；注意颈肩部保暖，避免头颈负重物，避免过度疲劳，坐车时不要打瞌睡。</p>
        </el-tab-pane>
        <el-tab-pane label="病史">
            <h4>病史</h4>
            <div class="med_s">
                <h5>2018年10月24日 22:10:20 <router-link to="/Peoplex/4"><el-tag size="medium" >脑膜炎</el-tag></router-link></h5>
                <p style="height: 200px;">
                    <el-steps direction="vertical" :active="2" finish-status="success">
                        <el-step title="住院" description="2017年10月10日"></el-step>
                        <el-step title="治疗阶段" description="2018年01月10日"></el-step>
                        <el-step title="康复" description="2018年02年10月"></el-step>
                    </el-steps>
                </p>
            </div>
            <div class="med_s">
                <h5>2018年09月12日 22:10:20 <router-link to="/Peoplex/4"><el-tag size="medium" type="danger" >感冒</el-tag></router-link></h5>
                <p style="height: 200px;">
                    <el-steps direction="vertical" :active="3" finish-status="success">
                        <el-step title="住院" description="2017年10月10日"></el-step>
                        <el-step title="治疗阶段" description="2018年01月10日"></el-step>
                        <el-step title="已康复" description="2018年02年10月"></el-step>
                    </el-steps>
                </p>
            </div>
            
        </el-tab-pane>
        <el-tab-pane label="血检">
            <h4>血检</h4>
            <h5>白细胞</h5>
            <p><el-tag  type="success" size="medium">10.8</el-tag> * 10.9 / L 3.5 ~ 9.5</p>
            <h5>红细胞</h5>
            <p><el-tag  type="success" size="medium">3.99</el-tag> * 10.12 / L 参考值：3.80 ~ 9.50</p>
            <h5>白细胞</h5>
            <p><el-tag  type="success" size="medium">10.8</el-tag> * 10.9 / L 3.5 ~ 9.5</p>
            <h5>红细胞</h5>
            <p><el-tag  type="success" size="medium">3.99</el-tag> * 10.12 / L 参考值：3.80 ~ 9.50</p>
            <h5>白细胞</h5>
            <p><el-tag  type="success" size="medium">10.8</el-tag> * 10.9 / L 3.5 ~ 9.5</p>
            <h5>红细胞</h5>
            <p><el-tag  type="success" size="medium">3.99</el-tag> * 10.12 / L 参考值：3.80 ~ 9.50</p>
        </el-tab-pane>
        <el-tab-pane label="X光">
            <h4>X光</h4>
            <h5>2018年10月12日 10:20:30</h5>
            <p>腰部有明显断层</p>
            <img src="https://cdn.nlark.com/yuque/0/2018/png/92616/1544711707123-dfabd712-81d2-4700-ac0b-fd0ef3e8b294.png" alt="">
            <h5>拍片医师</h5>
            <p>
                <router-link to="/Peoplex/3">
                    <el-tag  type="success" size="medium">王安安</el-tag>
                </router-link>
            </p>
            <h5>诊断意见</h5>
            <p>马上手术</p>

        </el-tab-pane>
        <el-tab-pane label="B超">
            <h4>B超</h4>
            <h5>2018年10月10日 10:23:30</h5>
            <p>胃部已经断层</p>
            <img src="https://cdn.nlark.com/yuque/0/2018/png/92616/1544712332550-cfe434ea-5cf6-407a-9038-a18ad9c0ae3e.png" alt="">
            <h5>拍片医师</h5>
            <p> <el-tag  type="success" size="medium">孙医生</el-tag></p>
            <h5>诊断意见</h5>
            <p>马上手术</p>
        </el-tab-pane>
        <el-tab-pane label="留言">
            <h4>留言</h4>
            <h5>拍片</h5>
            <p>复查时带上自己拍的片子</p>
        </el-tab-pane>
    </el-tabs>
    
    <div class="left_top">
        <h1>患者</h1>
    </div>


    
</div>
</template>

<script>
import drug from '~/components/drug.vue';
import drug3 from '~/components/drug3.vue';



export default {
  name: 'people',
  data() {
    return {
        tabPosition: 'left'
    }
  },
  components: {
        drug,
        drug3
  },
  methods: {
     

  },
  watch: {

  },
  created() {

  },
}
</script>

<style scoped lang="scss">
@media screen and (max-width:900px) {
    .drug_p{
        padding: 8px;
        margin-top: 15px;
        background: #f2f3f5;
        border-radius: 3px;
        .drug:first-child{
            margin-top: 0;
        }
    }
    
}

.people{
    position: relative;
    .left_top{
        position: absolute;
        top:-30px;
        right:-5px;
        background: #409EFF;
        color:#fff;
        width:30px;
        height:30px;
        line-height: 30px;
        font-size: 5px;
        text-align: center;
        border-radius: 100%;
        h1{
            margin: 0;
        }
    }
}

h3:after {
    content: " ";
    width: 14px;
    height: 6px;
    background-color: #409EFF;
    display: block;
    margin: 12px 0 20px;
}
img{
    border-radius: 3px;
}

h5{
    font-size: 15px;
    color: #123;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 1px;
}
p{
    font-size: 14px;
    font-weight: 300;
    color: #231f20;
    padding: 5px 0;  
    margin:7px 0 0 0;
}
.people{
    margin-bottom: 15px;
}
.el-tab-pane{
    h4{
        margin-top: 0px;
    }
    .el-tag--medium{
        margin-top: 5px;
    }
}

.c-t{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 15px;
}

.c-t.l_f{
    justify-content: flex-start;
}

.med_s{
   background: #ebeef5; 
   border-radius: 3px;
   padding: 15px;
   margin-bottom: 15px;
   h5{
       margin-top: 5px;
   }
}


@media screen and (min-width:900px) {
    .drug_p{
        padding: 10px;
        margin-top: 15px;
        background: #f2f3f5;
        border-radius: 3px;
        .drug:first-child{
            margin-top: 0;
        }
    }
}


</style>





// WEBPACK FOOTER //
// src/components/people.vue